var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecycleGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17189 4.87892L4.7618 4.87885C4.90569 4.5235 5.08605 4.18199 5.30115 3.86006C5.92218 2.93062 6.80488 2.20621 7.83762 1.77844C8.87037 1.35066 10.0068 1.23874 11.1031 1.45681C12.1995 1.67489 13.2065 2.21318 13.997 3.0036L14.9502 2.05032C13.9713 1.07135 12.724 0.404664 11.3661 0.134567C10.0083 -0.135529 8.60079 0.00309384 7.32171 0.532907C6.04263 1.06272 4.94938 1.95993 4.18021 3.11107C3.81312 3.66046 3.52771 4.25591 3.32964 4.87881L0.808105 4.87874L3.00014 7.07077L3.99008 8.06072L7.17189 4.87892ZM12.8287 9.12156L15.2391 9.12149C15.0952 9.47677 14.9149 9.81821 14.6998 10.1401C14.0788 11.0695 13.1961 11.7939 12.1634 12.2217C11.1306 12.6495 9.99423 12.7614 8.89787 12.5433C7.80152 12.3252 6.79446 11.787 6.00403 10.9965L5.05075 11.9498C6.02971 12.9288 7.277 13.5955 8.63486 13.8656C9.99273 14.1357 11.4002 13.997 12.6793 13.4672C13.9584 12.9374 15.0516 12.0402 15.8208 10.8891C16.1878 10.3397 16.4732 9.74431 16.6713 9.12145L19.1929 9.12139L17.0009 6.92935L16.0109 5.9394L12.8287 9.12156Z",
    fill: "#4F5F72",
    fillOpacity: 0.32
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleGrey);
export default __webpack_public_path__ + "static/media/recycle_grey.b487a8fd.svg";
export { ForwardRef as ReactComponent };